import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Linkedin, Youtube, Phone, Mail } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="bg-ink text-neutral-300">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <Logo variant="light" size="md" />
          <p className="mt-3 text-xs text-neutral-400 max-w-md leading-relaxed">Your all-in-one vehicle&apos;s digital shield. Privacy-first QR tags with masked calls, RSA support and service history — all in one tag. <span className="text-neutral-500">A venture of Explore Biz &middot; Since 2013</span></p>

          <div className="mt-4 grid sm:grid-cols-3 gap-x-4 gap-y-3 text-[11px] text-neutral-400">
            <div>
              <p className="uppercase tracking-widest text-neutral-500 text-[9px] font-semibold">Corporate Office</p>
              <p className="mt-1 leading-snug">1st Floor, Plot No. 9, Opp. Welcare Hospital, Atladara, Vadodara &ndash; 390012</p>
            </div>
            <div>
              <p className="uppercase tracking-widest text-neutral-500 text-[9px] font-semibold">Registered Office</p>
              <p className="mt-1 leading-snug">2nd Floor, Kevalam Corner, KKV Circle, 150 Feet Ring Road, Rajkot &ndash; 360005</p>
            </div>
            <div>
              <p className="uppercase tracking-widest text-neutral-500 text-[9px] font-semibold">Support</p>
              <a href="tel:+919228143222" className="mt-1 flex items-center gap-1.5 text-neutral-300 hover:text-white transition-colors" data-testid="footer-support-phone"><Phone size={11} className="text-orange-300" /> +91 92281 43222</a>
              <a href="mailto:connectnearme1@gmail.com" className="mt-1 flex items-center gap-1.5 text-neutral-300 hover:text-white transition-colors" data-testid="footer-support-email"><Mail size={11} className="text-orange-300" /> connectnearme1@gmail.com</a>
              <div className="flex gap-2 mt-2.5">
                {[Youtube, Instagram, Facebook, Twitter, Linkedin].map((Ic, i) => (
                  <button key={i} className="w-7 h-7 rounded-full border border-white/15 flex items-center justify-center hover:bg-white/5 transition-colors" aria-label="Social link"><Ic size={12} /></button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div>
          <h4 className="eyebrow !text-neutral-500 mb-3">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:text-white">Return &amp; Refund Policy</Link></li>
            <li><Link to="/faq" className="hover:text-white">FAQ / Terms of Service</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow !text-neutral-500 mb-3">Shop &amp; Partners</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-white">Shop tags</Link></li>
            <li><Link to="/partner" className="hover:text-white">Become a Partner</Link></li>
            <li><Link to="/how-it-works" className="hover:text-white">How it works</Link></li>
            <li><Link to="/login" className="hover:text-white">Customer Login</Link></li>
            <li><Link to="/partner/login" className="hover:text-white">Partner Login</Link></li>
            <li><Link to="/admin/login" className="hover:text-white text-neutral-500">Admin</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center text-xs text-neutral-500 gap-2">
          <p>&copy; Explore Biz. All Rights Reserved.</p>
          <p>Made in India</p>
        </div>
      </div>
    </footer>
  );
}
